import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function EventIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            className='icon'
            {...rest} >
            <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="2"/>
            <path d="M3.5 11H21" stroke={color} strokeWidth="2"/>
            <path d="M7 3V7" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M17 3V7" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

export default EventIcon;
